import React from "react";

const PageTitle = (props) => {
    return (
        <h1 className={"text-[42px] leading-none font-medium " + props.className}>
            {props.children}
        </h1>
    )
}

export default PageTitle